site.eucookie = {
	init: function() {
		if($.cookie('moyaEUcookie') == undefined) {
			var d = $('#eucookie');
			d.show();
			d.find('.close').bind('click',function() {
				$.cookie('moyaEUcookie',true,999);
				d.hide();
			});
		}
	}
};

site.inits.push('site.eucookie.init()');
